var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-representation"},[_c('div',{staticClass:"up"},[_vm._v(" "+_vm._s(_vm.day)+"."+_vm._s(_vm.month)+" ")]),_c('div',{staticClass:"down"},[_vm._v(" "+_vm._s(_vm.year)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }